import * as React from "react";
import LogOverview from "../../DAMS/Tabs/LogOverview";

/**
 * This is the Logs tab in the Hub module. It is a wrapper around the KafkaEventsPage from the Hub module.
 */

export const Logs: React.FC = () => {
    return <LogOverview/>
}
